import { amphtml } from '../../google-amp/react_amp'
export interface AmpSharingProps {
    type: string
    class?: string
    width: number
    height: number
}

export const AmpSharing = amphtml<AmpSharingProps>('social-share')
